import jQuery from "jquery";
window.$ = window.jQuery = jQuery;


require("./jquery/jquery-ui.min.js");
require("jquery-lazy");
require("./jquery/jquery.lazy.ajax.min.js");

/*
require('./bootstrap/tether.min.js');
require('./bootstrap/bootstrap.min.js');
*/
require('bootstrap');

require('./jquery/jquery.nicescroll.min.js');
require('./jquery/jquery.touchSwipe.min.js');
require('./fancybox/3.3.5/jquery.fancybox.min.js');
require('./flexslider/js/jquery.flexslider.js');
require('./slick/slick.js');

import TweenMax from "gsap/TweenMax";

import App from "./app/app.js";
import Home from "./app/home.js";
import Product from "./app/product.js";
import Taxonomies from "./app/taxonomies.js";
import Story from "./app/story.js";
import formContact from "./app/form-contact.js";

window.onload = () => {
	
	
	let app = new App();
	app.init();
	
	
	if(window.loadQueue){
		if(window.loadQueue.page == "home"){
			let home = new Home();
			home.init(window.loadQueue.setUp);
		}
		if(window.loadQueue.page == "product"){
			let product = new Product();
			product.init();
		}
		
		if(window.loadQueue.page == "taxonomy"){
			let taxonomies = new Taxonomies();
			taxonomies.init();
		}
		
		if(window.loadQueue.page == "story"){
			let story = new Story();
			story.init();
		}
		
		if(window.loadQueue.page == "contact"){
			formContact.init();
		}
	}

}